import Icon from '../../components/Icon.vue'

Icon.register({
  'regular/pause-circle': {
    width: 512,
    height: 512,
    paths: [
      {
        d: 'M256 8c137 0 248 111 248 248s-111 248-248 248-248-111-248-248 111-248 248-248zM256 456c110.5 0 200-89.5 200-200s-89.5-200-200-200-200 89.5-200 200 89.5 200 200 200zM352 176v160c0 8.8-7.2 16-16 16h-48c-8.8 0-16-7.2-16-16v-160c0-8.8 7.2-16 16-16h48c8.8 0 16 7.2 16 16zM240 176v160c0 8.8-7.2 16-16 16h-48c-8.8 0-16-7.2-16-16v-160c0-8.8 7.2-16 16-16h48c8.8 0 16 7.2 16 16z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/regular/pause-circle.js
// module id = 1806
// module chunks = 0